"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const formik_1 = require("formik");
const yup = __importStar(require("yup"));
const users_1 = require("@/store/ducks/users");
const selectors_1 = require("@/store/ducks/users/selectors");
const createUserUseCase_1 = require("@/useCases/users/createUserUseCase");
const index_view_1 = __importDefault(require("./index.view"));
function CreateUserModal() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isModalVisible = (0, react_redux_1.useSelector)(selectors_1.isCreateUserModalOpenSelector);
    const isLoading = (0, react_redux_1.useSelector)(selectors_1.isSavingUserSelector);
    const saveChangeSuccess = (0, react_redux_1.useSelector)(selectors_1.saveChangesSuccessSelector);
    const onCloseModal = react_1.default.useCallback(() => {
        dispatch((0, users_1.closeCreateUserModal)());
    }, []);
    const initialValues = {
        username: "",
        email: "",
        department: undefined,
        roles: [],
    };
    const validationSchema = yup.object().shape({
        username: yup.string().required("Name is required"),
        email: yup.string().required("Email is required"),
        deparment: yup.string(),
        roles: yup
            .array()
            .of(yup.string().required("Required"))
            .min(1, "Select at lest one role"),
    });
    const onSubmit = (values, formikHelpers) => {
        (0, createUserUseCase_1.createUserUseCase)(values)(dispatch).then(() => {
            if (saveChangeSuccess) {
                formikHelpers.resetForm();
            }
        });
    };
    return (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, enableReinitialize: true, validationSchema: validationSchema, onSubmit: onSubmit, validateOnBlur: true }, (props) => {
        return (react_1.default.createElement(index_view_1.default, { onSelectRole: props.handleChange, onSelectDeparment: props.handleChange, formTitle: "Add New User", onBlur: props.handleBlur, values: props.values, onSubmit: props.handleSubmit, errors: props.errors, confirmActionText: "Add user", touched: props.touched, isLoading: isLoading, onChange: props.handleChange, onClose: onCloseModal, isOpen: isModalVisible }));
    }));
}
exports.default = CreateUserModal;
